import { useWorkshopByIdQuery } from '../api/use-workshop-by-Id.query';
import { ContactDialogReferenceType, CustomerData } from 'api-new/generated';
import { useNewContact } from 'components/new-contact/use-new-contact';
import { useEffect, useState } from 'react';

const customerDefault: CustomerData = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  fullName: ''
};

export const useNewContactWithWorkshop = (
  data: { id?: number; soHeaderId?: number | null },
  enableWorkshopRequest: boolean
) => {
  const [contactState, setContactState] = useState<{ needReload: boolean; customerData: CustomerData }>({
    needReload: false,
    customerData: customerDefault
  });

  const { handleCheckIfDialogExists } = useNewContact(
    contactState.customerData,
    data.id ?? -1,
    ContactDialogReferenceType.WorkshopLog
  );

  const { refetch: refetchWorkshop, isFetching: isFetchingWorkshop } = useWorkshopByIdQuery(
    { soHeaderId: data?.soHeaderId ?? -1 },
    [data.id],
    {
      enabled: enableWorkshopRequest,
      onSuccess: ({ contact, customer }) => {
        if (!customer && !contact) return;

        setContactState({
          needReload: true,
          customerData: {
            title: customer?.title ?? '',
            titleId: customer?.titleId,
            firstName: customer?.firstName ?? '',
            lastName: customer?.lastName ?? '',
            email: contact?.email ?? '',
            phone: contact?.phone ?? '',
            fullName: customer?.fullName ?? ''
          }
        });
      }
    }
  );

  useEffect(() => {
    if (contactState.needReload) {
      handleCheckIfDialogExists();
      setContactState((st) => ({
        ...st,
        needReload: false
      }));

      return;
    }
  }, [contactState]);

  return { refetchWorkshop, isFetchingWorkshop, customerData: contactState.customerData };
};
